<template>
  <div>
    <vue-element-loading
      :active="appLoading"
      spinner="bar-fade-scale"
      color="#1976d2"
      size="50"
      is-full-screen
    />
    <v-layout v-if="ServerError" wrap justify-center>
      <v-flex px-5 pt-5 xs12 sm12 md12 lg12 xl12 text-center>
        <ServerError />
      </v-flex>
    </v-layout>
    <v-snackbar v-model="showsnackbar" color="#9eaade" right :timeout="timeout">
      <v-layout wrap justify-center>
        <v-flex text-left class="align-self-center">{{ msg }}</v-flex>
        <v-flex text-right>
          <v-btn small :ripple="false" text @click="showsnackbar = false">
            <v-icon style="color: white">mdi-close</v-icon>
          </v-btn>
        </v-flex>
      </v-layout>
    </v-snackbar>
    <v-layout justify-center wrap>
      <v-flex xs12 pt-5>
        <v-card>
          <v-layout justify-start wrap py-6>
            <v-layout justify-center wrap>
              <v-flex xs3 sm3 md3 pl-5 text-center>
                <v-icon color="#9B8DFD">mdi-school</v-icon>
              </v-flex>
              <v-flex xs9 sm9 md9 text-left>
                <router-link :to="'/schoolList'" style="text-decoration: none">
                  <span
                    style="
                      font-family: nunitosansbold;
                      font-size: 20px;
                      color: #000000;
                    "
                    >View School</span
                  >
                </router-link>
              </v-flex>
            </v-layout>
            <v-flex xs6 sm6 md9>
              <router-link :to="'/schoolAdd'" style="text-decoration: none">
                <span
                  style="
                    color: #797979;
                    font-family: nunitosanssemibold;
                    font-size: 18px;
                  "
                  >Add School</span
                >
              </router-link>
            </v-flex></v-layout
          >
        </v-card>
        <v-layout justify-center wrap pt-10 pb-5 v-if="school.length > 0">
          <v-flex xs12>
            <span style="font-family: nunitosansbold; font-size: 20px"
              >View School</span
            ><br />
            <v-layout justify-start wrap>
              <v-flex
                xs12
                sm6
                md4
                lg4
                xl4
                v-for="(list, index) in school"
                :key="index"
                pa-2
              >
                <v-card>
                  <v-card-text>
                    <v-layout justify-center wrap>
                      <v-flex xs4 sm4 md4 lg3 pt-2>
                        <v-avatar style="cursor: pointer" size="48">
                          <v-img
                            width="40px"
                            :src="mediaURL + list.image"
                          ></v-img>
                        </v-avatar>
                      </v-flex>
                      <v-flex xs6 sm6 md6 lg7 pt-3>
                        <router-link
                          :to="'/schoolView?school=' + list._id"
                          style="text-decoration: none"
                        >
                          <span
                            style="color: #000000; font-family: nunitosansbold"
                            >{{ list.name }}</span
                          ><br />
                        </router-link>
                        <!-- <span
                          style="
                            color: #000000;
                            font-family: nunitosanssemibold;
                          "
                          >{{ list.address }}</span
                        > -->
                      </v-flex>
                      <v-flex xs1 pt-2>
                        <v-icon
                          small
                          class="mr-2"
                          outlined
                          block
                          @click="editSlider(list)"
                        >
                          mdi-pencil
                        </v-icon>
                      </v-flex>
                      <v-flex xs1 pt-2>
                        <v-dialog v-model="list.delete" max-width="600px">
                          <template v-slot:activator="{ on, attrs }">
                            <v-icon size="15" v-on="on" v-bind="attrs"
                              >mdi-close</v-icon
                            >
                          </template>
                          <v-card>
                            <v-card-title
                              style="font-family: nunitosansregular"
                            >
                              Are you sure you want to delete this school?
                            </v-card-title>
                            <v-card-actions>
                              <v-spacer></v-spacer>
                              <v-btn
                                color="blue darken-1"
                                text
                                @click="list.delete = false"
                                >Cancel</v-btn
                              >
                              <v-btn
                                color="blue darken-1"
                                text
                                @click="deleteItem(list._id)"
                                >OK</v-btn
                              >
                              <v-spacer></v-spacer>
                            </v-card-actions>
                          </v-card>
                        </v-dialog>
                      </v-flex>
                    </v-layout>
                  </v-card-text>
                </v-card>
              </v-flex>
            </v-layout>
            <v-dialog v-model="editdialog" max-width="800px">
              <v-card>
                <v-card-title>
                  <span class="headline">Edit School</span>
                </v-card-title>
                <v-card-text>
                  <v-layout justify-center wrap>
                    <v-flex xs12>
                      <v-text-field
                        style="font-family: nunitosansregular"
                        outlined
                        dense
                        v-model="editingitem.name"
                        label="Name of the School"
                      ></v-text-field>
                    </v-flex>
                    <v-flex xs12>
                      <v-text-field
                        style="font-family: nunitosansregular"
                        outlined
                        dense
                        v-model="editingitem.address"
                        label="Address of the School"
                      ></v-text-field>
                    </v-flex>
                    <v-layout justify-start wrap pl-2 pb-5>
                      <v-flex xs12>
                        <img
                          v-if="imagePreview"
                          :src="imagePreview"
                          v-show="showPreview"
                          width="390px"
                          height="150px"
                          class="align-center"
                          contain
                        />
                        <img
                          v-else
                          :src="mediaURL + editingitem.image"
                          width="390px"
                          height="150px"
                          class="align-center"
                          contain
                        />
                      </v-flex>
                      <v-flex xs12 sm7 md6 lg6>
                        <v-btn
                          width="180px"
                          block
                          tile
                          depressed
                          :ripple="false"
                          class="text-capitalize"
                          color="#F6F5FF"
                          @click="$refs.showImage.click()"
                        >
                          <v-layout justify-center wrap>
                            <v-flex xs2 sm2 md2 text-left>
                              <v-icon style="color: #000000">mdi-upload</v-icon>
                            </v-flex>
                            <v-flex xs10 sm8 md10>
                              <span class="image">Upload Image</span>
                            </v-flex>
                          </v-layout>
                        </v-btn>
                        <input
                          v-show="false"
                          accept="image/*"
                          id="file"
                          ref="showImage"
                          multiple="multiple"
                          type="file"
                          @change="showImage"
                        />
                      </v-flex>
                    </v-layout>
                  </v-layout>
                </v-card-text>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn color="blue darken-1" text @click="editdialog = false">
                    Close
                  </v-btn>
                  <v-btn
                    color="blue darken-1"
                    text
                    @click="edit(editingitem._id)"
                  >
                    Save
                  </v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>
          </v-flex>
        </v-layout>
        <div class="text-center" v-if="pages > 1">
          <v-pagination
            :length="pages"
            :total-visible="7"
            v-model="currentPage"
            color="#9B8DFD"
          ></v-pagination>
        </div>
      </v-flex>
    </v-layout>
  </div>
</template>
<script>
import axios from "axios";
export default {
  data() {
    return {
      hover: false,
      appLoading: false,
      showsnackbar: false,
      ServerError: false,
      msg: "",
      timeout: 5000,
      currentPage: 1,
      pages: 0,
      count: 4,
      totalData: 0,
      standard: "",
      school: [],
      studentList: [],
      page: 1,
      formDataCover: new FormData(),
      classArray: [],
      image: null,
      imagePreview: "",
      showPreview: false,
      file: null,
      editingitem: [],
      editdialog: false,
    };
  },
  watch: {
    currentPage() {
      this.getSchool();
    },
  },
  mounted() {
    this.getSchool();
  },
  methods: {
    getSearch() {
      this.appLoading = true;
      if (this.currentPage > 1) this.currentPage = 1;
      axios({
        method: "GET",
        url: "/school/getlist",
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
        params: {
          count: this.count,
          page: this.currentPage,
        },
      })
        .then((response) => {
          if (response.data.status) {
            this.school = response.data.data;
            this.pages = response.data.pages;
            this.totalData = response.data.count;
            this.appLoading = false;
          } else {
            this.msg = response.data.msg;
            this.showsnackbar = true;
          }
        })
        .catch((err) => {
          this.appLoading = false;
          this.ServerError = true;
          console.log(err);
        });
    },
    getSchool() {
      this.appLoading = true;
      axios({
        method: "GET",
        url: "/school/getlist",
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
        params: {
          count: this.count,
          page: this.currentPage,
        },
      })
        .then((response) => {
          if (response.data.status) {
            this.school = response.data.data;
            this.pages = response.data.pages;
            this.totalData = response.data.count;
            this.appLoading = false;
          } else {
            this.msg = response.data.msg;
            this.showsnackbar = true;
          }
        })
        .catch((err) => {
          this.appLoading = false;
          this.ServerError = true;
          console.log(err);
        });
    },
    editSlider(item) {
      this.editingitem = item;
      this.editdialog = true;
    },
    showImage(e) {
      this.file = e.target.files[0];
      var reader = new FileReader();
      reader.onload = (e) => {
        this.$refs.showImage.value = null;
        this.imagePreview = e.target.result;
      };
      if (this.file.size > 2145728) {
        this.msg = "File Should be less than 2MB";
        this.showSnackBar = true;
        return;
      }
      this.showPreview = true;
      if (this.file) {
        if (/\.(jpe?g|png|gif)$/i.test(this.file.name)) {
          reader.readAsDataURL(this.file);
        }
      }
    },
    uploadImage(item) {
      this.formDataCover.append("image", this.file);
      this.formDataCover.append("id", item);
      axios({
        method: "POST",
        url: "/school/image",
        data: this.formDataCover,
        headers: {
          "Content-Type": "multipart/form-data",
          "x-auth-token": localStorage.getItem("token"),
        },
      })
        .then((response) => {
          if (response.data.status == true) {
            this.msg = "Upload Successfully";
            this.showSnackBar = true;
            this.formDataCover = new FormData();
            this.dialog = false;
            this.editdialog = false;
            this.getSchool();
          } else {
            this.msg = response.data.msg;
            this.showSnackBar = true;
          }
        })
        .catch((err) => {
          this.msg = "Can't Upload Cover Image.. Please Try Again Later";
          this.showSnackBar = true;
          console.log(err);
        });
    },
    edit() {
      this.appLoading = true;
      var user = {};
      user["name"] = this.editingitem.name;
      user["address"] = this.editingitem.address;
      user["id"] = this.editingitem;
      axios({
        method: "POST",
        url: "/school/edit",
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
        data: user,
      })
        .then((response) => {
          this.appLoading = false;
          if (response.data.status) {
            this.editdialog = false;
            this.getSchool();
            if (this.imagePreview) {
              this.uploadImage(this.editingitem._id);
            }
          } else {
            this.msg = "Can't Update";
            this.showSnackBar = true;
          }
        })
        .catch((err) => {
          this.appLoading = false;
          this.ServerError = true;
          console.log(err);
        });
    },
    deleteItem(r) {
      var data = {};
      data["id"] = r;
      axios({
        url: "/school/remove",
        method: "POST",
        data: data,
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
      })
        .then((response) => {
          this.delete = false;
          this.appLoading = false;
          if (response.data.status) {
            this.msg = "Delete Sucessfully";
            this.showsnackbar = true;
            this.getSchool();
          } else {
            this.msg = response.data.msg;
            this.showsnackbar = true;
          }
        })
        .catch((err) => {
          this.appLoading = false;
          this.ServerError = true;
          console.log(err);
        });
    },
  },
};
</script>